import * as React from 'react'
import { LayoutWithLeftSidebar } from '../views/LayoutWithLeftSidebar/LayoutWithLeftSidebar'
import { NotAuthorizedPageContent } from './NotAuthorizedPageContent'

const NotAuthorizedPage: React.FC = () => {
  return (
    <LayoutWithLeftSidebar>
      <NotAuthorizedPageContent />
    </LayoutWithLeftSidebar>
  )
}

export default NotAuthorizedPage
